<script lang="ts" setup>
  import { useRouter } from 'vue-router';
  const router = useRouter();
  function goHelp() {
    router.push('/help');
  }
</script>
<template>
  <a-button type="link" @click="goHelp">帮助与公告</a-button>
</template>
<style scoped lang="less">
  .gitee-logo {
    width: 20px;
  }
  .action-item {
    font-size: 20px;
    height: 100%;
    margin: 0 -8px;
    padding: 0 4px;
    line-height: 40px;
    display: flex;
    align-items: center;

    &.setting {
      font-size: 18px;
    }

    &.notice {
      font-size: 18px;
    }
  }
</style>
